<form
  [formGroup]="form"
  class="row"
>
  <div class="col-12 col-lg-6">
    <h4>Salary range annually</h4>
    <div class="row">
      <div class="col-4">
        <mojo-currency-dropdown
          [parentForm]="form"
          controlName="salaryCurrency"
        >
        </mojo-currency-dropdown>
      </div>
      <mat-form-field
        color="accent"
        class="col-4 pl-0"
      >
        <mat-label>Min</mat-label>
        <input
          matInput
          id="minSalary"
          formControlName="minSalary"
          placeholder="Min"
          mask="coma_separator"
          data-cy="basic-job-min-salary-input"
        >
      </mat-form-field>
      <mat-form-field
        color="accent"
        class="col-4 pl-0"
      >
        <mat-label>Max</mat-label>
        <input
          matInput
          id="maxSalary"
          formControlName="maxSalary"
          placeholder="Max"
          mask="coma_separator"
          data-cy="basic-job-max-salary-input"
        >
      </mat-form-field>
    </div>
  </div>
  <div class="col-12 col-lg-6">
    <h4>Commission range</h4>
    <div class="row">
      <mat-form-field
        color="accent"
        class="col-6"
      >
        <mat-label>Commission %</mat-label>
        <input
          matInput
          id="commission"
          formControlName="commission"
          placeholder="Commission %"
          mask="coma_separator"
          data-cy="basic-job-bonus-salary-input"
        >
      </mat-form-field>
      <div
        class="col-3"
        *ngIf="form?.get('minSalary')"
      >
        <div class="min-max-label">Min</div>
        <div class="min-max-value">
          {{ (form?.get('commission')?.value * form.get('minSalary').value / 100) | number }}
        </div>
      </div>

      <div
        class="col-3"
        *ngIf="form?.get('maxSalary')"
      >
        <div class="min-max-label">Max</div>
        <div class="min-max-value">
          {{ (form?.get('commission')?.value * form.get('maxSalary').value / 100) | number }}
        </div>
      </div>
    </div>
  </div>
</form>
